<template>
	<b-container fluid class="d-flex flex-column h-100 w-100 bg-white" :style="generateVariantStyle(Variant)">
		<!-- barre d'êtat / menu -->
		<b-row class="w-100 p-0">
            <b-col class="p-0 ">
                <b-container fluid class="h-100 d-flex justify-content-end mt-2 pr-0">
                    <b-row>
						<b-col v-if="!FSButtonPortalName" class="px-1">
							<hsc-menu-style-custom  v-if="results && (('menus') in results)">
								<hsc-menu-button-menu ref="axisContextMenu" class="menu w-100" :menuZIndex="3" :Index="0">
                                    <b-button v-b-tooltip.hover :title="$t('AxisSettings')"
                                              variant="outline-black" class="p-1 border-0 btn-circle-small">
                                        <b-icon icon="gear"/>
                                    </b-button>

									<!-- <template slot="contextmenu">
										<div class="text-uppercase">Consommation EF Fact / SHON / Surface utile</div>
										<hsc-menu-item label="Décimales" >
											<hsc-menu-item label="0" />
											<hsc-menu-item label="1" />
											<hsc-menu-item label="2" />
											<hsc-menu-item label="3" />
										</hsc-menu-item>

										<hsc-menu-item label="Unités" >
											<hsc-menu-item label="Consommation EF">
												<hsc-menu-item label="Unit1" />
												<hsc-menu-item label="Unit2" />
											</hsc-menu-item>
											<hsc-menu-item label="SHON" >
												<hsc-menu-item label="Unit3" />
												<hsc-menu-item label="Unit4" />
											</hsc-menu-item>
											<hsc-menu-item label="Surface utile" >
												<hsc-menu-item label="Unit5" />
												<hsc-menu-item label="Unit6" />
											</hsc-menu-item>
										</hsc-menu-item>
									</template> -->

								</hsc-menu-button-menu>
							</hsc-menu-style-custom>
						</b-col>

						<!-- Portal pour bouton de plein écran -->
						<!-- Utilisé dans un portal (Ex : widget) -->
						<portal v-if="FSButtonPortalName" :to="FSButtonPortalName" :disabled="FSButtonPortalName == undefined">
							<b-icon @click="fullscreen = true" v-b-tooltip.hover :title="$t('FullscreenMode')" icon="fullscreen" role="button" />
						</portal>
						<b-col v-else class="m-0 p-0 pl-1 border-left">
							<!-- Pas widget -->
							<b-button @click="fullscreen = true" v-b-tooltip.hover :title="$t('FullscreenMode')" variant="outline-black" class="p-1 border-0 btn-circle-small m-0" >
								<b-icon icon="fullscreen" />
							</b-button>
						</b-col>
					</b-row>
				</b-container>
			</b-col>
		</b-row>

		<!-- Chargement du tableau -->
		<b-row class="h-100" v-if="Loading || results" >
			<b-skeleton-wrapper :loading="Loading" class="row w-100 h-100 p-0 m-0">
                <!-- Mise en forme pendant le chargement des données -->
                <template #loading>
					<b-col align-self="center">
                        <div class="b-skeleton w-100 b-skeleton-icon b-skeleton-animate-fade bg-transparent text-gray-middle-dark" align-v="center">
                            <font-awesome-icon icon="table-cells" size="6x" class="w-100" />
                        </div>
                    </b-col>
				</template>
				<!-- Affichage du tableau -->
				<template v-if="results?.rows?.length > 0">
					<portal :to="$id('FsGridWork')" :disabled="!fullscreen" class="w-100 px-3">
						<div v-if="showWeightTitle" class="font-weight-bold">
								* {{ $t('ComputedFactorValue') }}
						</div>
						<b-table-simple :id="$id('GridWork')" hover small responsive bordered no-border-collapse :sticky-header="fullscreen ? '85vh' : MaxHeight" class="mb-0 pb-0 overflow-auto" table-class="h-100" >
							<colgroup>
								<!-- EXCEPTIONNELLEMENT : Fabien a dit que j'ai le droit de mettre un style -->
								<col style="width: 1.5rem;">
							</colgroup>
							<colgroup v-if="headers?.at(0)?.find(x => x.Key == 'Icon')">
								<col style="width: 1.5rem;">
							</colgroup>
							<b-thead head-variant="unset" >
								<b-tr v-for="(field, index) in headers" :key="index" class="text-center w-100 text-nowrap" >
									<b-th :id="$id(header.Key)" v-for="header in headers[index]" :key="header.Key" :rowspan="header.RowSpan" :colspan="header.ColSpan" :sticky-column="!header.Key.toString().includes('Data')" :class="['align-middle', 'bg-white', {'stickyCol': !header.Key.toString().includes('Data')}]" >
										<div v-if="header.Sortable === true && header.Label != ''" @click="sortColumn(header.Key, results.rows)" style="cursor: pointer;" >
											<!-- Icone de tri affiché est inversé car nextSort correspond au tri suivant ! -->
											{{ header.Label }}<font-awesome-icon :icon="nextSort == sortEnum.Asc ? 'sort-down' : 'sort-up'" class="ml-2" />
										</div>
										<div v-else-if="String(header.Key).match(/Period\d+/) != null" v-html="getHeaderFormat(header.Label)" ></div>
										<div v-else>
											{{ header.Label }}
										</div>
									</b-th>
								</b-tr>
								<!-- Total affiché lorsqu'une pagination est existante -->
								<b-tr v-if="context?.UsePagination && totalRows() > perPage" class="bg-gray position-sticky" >
									<b-td :colspan="countTotalColSpan" sticky-column class="font-weight-bold text-center align-middle bg-gray">{{$t('Total')}}</b-td>
									<b-td v-for="(value,key) in lowestHeaders" v-if="key.toString().includes('Data')" :key="key" class="text-right align-middle">
										{{ sumColumns(key, results.rows) }}
									</b-td>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr v-for="row in rows()" :key="row.Name" class="text-nowrap p-0" >
									<b-td v-for="(value, key) in lowestHeaders" :key="key" :sticky-column="!key.toString().includes('Data')" :class="['align-middle', {'bg-white stickyCol' : !key.toString().includes('Data')}]" >
										<!-- Formatage Date -->
										<div v-if="lowestHeaders[key] == 'Date'">
											{{ periodFormat(row[key], lPeriodicity, lCompare) }}
										</div>
										<!-- Formatage Decimal -->
										<div v-else-if="lowestHeaders[key] == 'Decimal'" class="text-right">
											<!-- || row[key] == 0 ajouté car si cond. ternaire égale 0 => retourne la seconde valeur de la ternaire  -->
											{{ row[key] || row[key] == 0 ? Intl.NumberFormat(navLanguage, { 
												maximumFractionDigits: getDataPropertyValue(key, 'decimal')
											}).format(row[key]) : ''}}
										</div>
										<!-- Affichage Icône -->
										<div v-else-if="String(row[key]).includes('Icons')">
											<b-img :src="AbsoluteLink(row[key] + '.svg')" height="20" width="20" />
										</div>
										<!-- Formatage Chaine ( + format pour donnée recalculée ) -->
										<div v-else-if="lowestHeaders[key] == 'String'" :class="['text-left', {'font-weight-bold text-right' : String(row[key]).includes('*') }]">
											<!-- 1er temps : affichage ou non astérique pour valeur recalculé si dans la chaîne. 
											 	 2nd temps : format numérique de la valeur splité pour le cas avec astérisque dans la chaîne

												Condition Number() pour vérifier si valeur numérique présente (ex: donnée de facteur) sison simple chaine de caractère 	
											-->
											{{ Number(row[key]) ? ((String(row[key]).includes('*') ? "*" : "") +
											   Intl.NumberFormat(navLanguage, { maximumFractionDigits : getDataPropertyValue(key, 'decimal')})
											   .format(String(row[key]).includes('*') ? Number(String(row[key]).split('*').at(1)) : row[key])) : row[key]
											}}
										</div>
										<!-- Formatage pour la colonne State -->
										<div v-else-if="key == 'State'">
														<!-- Si l'état est renseigné, on affiche une pastille de couleur correspondant à cet état -->
														<b-icon v-if="row[key]" v-b-tooltip.hover :title="getStateTooltip(row[key])" icon="circle-fill" :class="getStateColor(row[key])" />
										</div>
										<!-- Autre Formatage -->
										<!-- <div v-else-if="row[key]">
											<b-icon icon="circle-fill" :class="{'text-success': row[key] == '0'}" />
										</div> -->
									</b-td>
								</b-tr>
							</b-tbody>
							<b-tfoot class="position-sticky bg-white">
								<!-- Sous-total -->
								<b-tr v-if="context?.UsePagination && totalRows() > perPage" class="bg-gray">
									<b-td :colspan="countTotalColSpan" sticky-column class="font-weight-bold text-center align-middle bg-gray">{{ $t('SubTotal') }}</b-td>
									<b-td v-for="(value,key) in lowestHeaders" v-if="key.toString().includes('Data')" :key="key" class="text-right align-middle">
										{{ sumColumns(key, rows()) }}
									</b-td>
								</b-tr>
								
								<!-- Total affiché lorsqu'une pagination est masquée -->
								<b-tr v-if="!(context?.UsePagination && totalRows() > perPage)" class="bg-gray" >
									<b-td :colspan="countTotalColSpan" sticky-column class="font-weight-bold text-center align-middle bg-gray">{{ $t('Total') }}</b-td>
									<b-td v-for="(value,key) in lowestHeaders" v-if="key.toString().includes('Data')" :key="key" class="text-right align-middle">
										{{ sumColumns(key, results.rows) }}
									</b-td>
								</b-tr>
							</b-tfoot>
							<caption class="p-0 px-2">
								<b-row v-if="context?.UsePagination && totalRows() > perPage" align-h="between" class="w-100 py-1">
									<b-col>
										<b-pagination v-if="totalRows() > perPage" :total-rows="totalRows()" v-model="currentPage" :per-page="perPage" class="p-0 m-0"  >
											<template #page="{ page, active }" >
													{{ page }}
											</template>
										</b-pagination>
									</b-col>
									<b-col class="px-0"></b-col>
									<b-col class="text-right px-0" >
										{{ (currentPage * perPage > totalRows() ? totalRows() : currentPage * perPage) + " " + $t('On') + " " + totalRows() }}
									</b-col>
								</b-row>
							</caption>
						</b-table-simple>
					</portal>
				</template>
				<template v-else>
					<b-col class="h-100 w-100 px-3 pt-3" align-self="center">
						<b-alert :variant="Variant" show class="bold p-1" pill>
							<font-awesome-icon icon="table-cells" class="pr-2 fa-2xl"/>
							{{ $t('NoData') }}
						</b-alert>
					</b-col>
				</template>
			</b-skeleton-wrapper>
		</b-row>
		<!-- Fenêtre modale pour le mode fullscreen -->
		<b-modal :title="Title" v-model="fullscreen" centered hide-footer no-close-on-backdrop title-class="text-center w-100" header-class="p-0" dialog-class="fullscreen-modal" content-class="fullscreen-modal h-100">
			<portal-target :name="$id('FsGridWork')" class="w-100 px-3"  />
		</b-modal>
	</b-container>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Prop, Watch } from "vue-property-decorator";
	import { WorkExtended } from "../Work";
	import Dictionary from "@/types/Dictionary";
	import GridContext from "./GridWork/GridContext";
	import GridState from './GridWork/GridState';
	import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
	import { LinkUtils, TableUtils, ThemeUtils } from "@/components/commons/Utils";
	import Menu from "./Menu.vue";
	import moment from 'moment';
	import locales from "./locales/GridWork.json";

	/** Composant d'affichage de tableau */
	@Component({
		components: {
			'grid-menu': Menu,
			'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
		},
		i18n: { messages: locales }
	})
	export default class GridWork extends mixins(WorkExtended<GridContext>, TableUtils, LinkUtils, ThemeUtils) {
		/** Indique la hauteur maximale que peut prendre le tableau */
		@Prop({ default: '85vh'})
		public MaxHeight!: string;

		/** 
		 * Langue du navigateur utilisée
		 * @todo Gérer cette variable plus mieux car crado ==> Merci Fabien de t'en occuper !!!!
		 */
		private navLanguage: string = this.$store.getters['SessionStore/GetLanguage']; // navigator.language;

		/** Nombre d'éléments par page */
		private perPage: number = 6;

		/** Numéro de la page actuelle */
		private currentPage : number = 1;

		/** Tableau réprésentant les lignes et colonnes pour les en-têtes du tableau */
		private headers: any[][] = [[]]; 
		
		/** Dictionnaire représentant les en-têtes les plus bas et leur type  */
		private lowestHeaders : Dictionary<any> = {};

		/** Périodicité actuelle pour le tableau */
		private lPeriodicity : string = 'Year';

		private lCompare : boolean = false;

		/** Permet d'affcher le message indiquant que des valeurs recalculées sont présentes dans le tableau */
		private showWeightTitle : boolean = false;	

		/** Nombre de colonne pour les colspan des colonne de Total et de Sous-Total */
		private countTotalColSpan : number = 1;

		/** Changement d'êtat lors du mode plein ecran */
		@Watch('fullscreen', {immediate: true})
    	public changeFullscreen() {
			if (this.context) {
				console.debug("GridWork - changeFullscreen() - fullscreen : %O", this.fullscreen);
				if (this.fullscreen)
					this.context.GoFullscreen();
				else
					this.context.GoStandard();
			}
		}

		/**
		 * Watcher permettant la génération des champs et des données du tableau
		 */
		@Watch('Loading')
		private generateTableData(){
			this.headers = [];
			this.lowestHeaders = {};

			this.lPeriodicity = this.configs["Periods"].at(0).Periodicity;
			this.lCompare = this.configs["Periods"].at(0).Compare;
			this.showWeightTitle = false;

			if(this.results && "headers" in this.results){
				// Boucle pour créer les lignes d'en-têtes et déterminer la profondeur maximale
				for (let header of this.results.headers) {
					this.addRow(header, 0);
				}

				// Boucle pour créer les colonnes
				for (let header of this.results.headers) {
					this.addHeader(header, 0, this.headers.length);
				}

				// Valeur du colspan pour le total et le sous-total
				this.countTotalColSpan = this.headers.at(0).filter(x => !x.Key.includes('Data')).length;

				// Réinitialisation de la page courante à 1 apres chaque actualisation
				this.currentPage = 1;
			}
		}

		/**
		 * Méthode récursive pour ajouter une ligne dans les en-têtes
		 * @param header Liste des en-têtes
		 * @param level Niveau actuel de la ligne
		 */
		private addRow(header, level){
			// Vérification niveau existant dans headers
			if(this.headers.length < level + 1){
				this.headers.push([] = []);
			}

			level++;
			if(header.SubHeaders)
				for (let subHeader of header.SubHeaders) {
					this.addRow(subHeader, level);
				}
		}

		/**
		 * Permet de calculer le nombre de colonne selon les sous-entêtes, un niveau et une profondeur
		 * @param subHeaders Liste des en-têtes
		 * @param level Niveau actuel de l'element
		 * @param depth Profondeur maximale
		 */
		private addHeader(header, level, depth): number{
			let cols : number = 0;

			level++;
			if(header.SubHeaders){
				for (let subHeader of header.SubHeaders) {
					cols += this.addHeader(subHeader, level, depth);
				}
			}	
			level--;

			if(cols == 0)
				cols++;

			if(header.Weight)
				this.showWeightTitle = header.Weight;

			// Création de la colonne
			let col = {
				Label: header.Label,
				Key: header.Name,
				DataType : header.DataType,
				Sortable : header.Sortable,
				Weight : header.Weight,
				ColSpan: cols,
				RowSpan: cols == 1 && (header.SubHeaders == undefined || header.SubHeaders?.length == 0 ) ? depth - level : 1
			}

			this.headers[level].push(col);
			if(cols == 1 && (header.SubHeaders == undefined  || header.SubHeaders?.length == 0 ))
				this.lowestHeaders[col.Key] = col.DataType;

			return cols;
		}
		
		private getHeaderFormat(label){
			let comparePeriodicity = "Year";

			// mode comparaison
			if(this.lCompare){
				switch (this.lPeriodicity) {
					case "Day":
						comparePeriodicity = "Week";	
						break;
					case "Hour":
						comparePeriodicity = "DayColumn";
					default:
						break;
				}
			}

			//si la périodicité de comparaison est hebdo, on affiche en indice l'année
			if(comparePeriodicity == "Week")
			{
				let value : string = this.periodFormat(label, this.lCompare ? comparePeriodicity : this.lPeriodicity, false);

				let splitValue = value.split(" ");

				return  splitValue[0] + "<sub>" + splitValue[1] + "</sub>";
			}	

			return this.periodFormat(label, this.lCompare ? comparePeriodicity : this.lPeriodicity , this.lCompare);
		}


		/**
		 * Permet de formater les périodes selon une périodicité donnée
		 * @param value Période à formater
		 * @param periodicity Périodicité de la date
		 */
		private periodFormat(value, periodicity, isCompare){
			// Format de la période
			let format = "";
			let splitValue : string[] = value.split(' ');
			let date = splitValue[0];

			console.debug("GridWork - periodFormat splitValue : %O - date: %O - periodicity : %O - dateValid: %O ", splitValue, date, periodicity, moment(date));
			
			if(moment(date).isValid()){
				switch (periodicity) {
					case "Year":
						format = "YYYY";
						break;
					case "Month":
						format = isCompare ? "MMMM" : "MMMM YYYY";
						break;
					case "Week":
						// Si l'année de la fin de la semaine différent de la date renseigné (correspondant à la semaine 53), on veut modifier cette date pour qu'elle soit sur l'année suivante 
						if(moment(date).week() != moment(date).weekYear())
							date = moment(date).endOf("week").format("YYYY-MM-DD");
						
							format = isCompare ? "[" + this.$t('Week') + "]WW" : "[" + this.$t('ShortWeek') + "]WW YYYY";
						break;
					case "Day":
						format = isCompare ? "dddd" : "L";
						break;
					// "fausse" périodicité pour affichage spécifique sur les colonnes quand on fait une comparaison journalière 
					case "DayColumn":
						format = "DD/MM/YYYY";
						break;
					case "Hour":
						format = isCompare ? "HH:00" : "L HH:00";
						break;
					case "Minutes10":
						format = isCompare ? "HH:mm" : "L HH:mm";
						break;
				}

				console.debug("GridWork - periodFormat - format", this.$options.filters.formatDate(date, format))

				return this.$options.filters.formatDate(date, format) + ' ' + splitValue.slice(1).join(' ');
			}
			else
				return value;
		}

		/**
		 * Renvoie la classe css correspondant à la valeur de l'état renseignée
		 * @param value valeur de l'état
		 */
		private getStateColor(value : string) : string {
			let stateClass : string = "";
			
			switch(value) {
				case "0":
					stateClass = "text-success";
					break;
				case "1":
					stateClass = "text-danger";
					break;
				case "2":
					stateClass = "text-warning";
					break;
			}

			return stateClass;
		}

		/**
		 * Renvoie le texte d'infobulle correspondant à l'état renseigné
		 * @param value valeur de l'état
		 */
		private getStateTooltip(value : string) : string {
			let stateTooltip : string = "";

			switch(value) {
				case "0":
					stateTooltip =  this.$t("NoProblem").toString(); //"Aucun problème";
					break;
				case "1":
					stateTooltip =  this.$t("IncompleteDataPeriod").toString(); // "Données incomplètes sur la période";
					break;
				case "2":
					stateTooltip = this.$t("SynthesisIssue").toString(); // "Problème de synthèse";
					break;
			}

			return stateTooltip;
		}

		/** Retourne le nombre de lignes selon le contexte */
		private rows() : any[] {
			const items = this.results?.rows;

			// Return just page of items needed
			if(this.context && this.context.UsePagination){
				return items?.slice(
					(this.currentPage - 1) * this.perPage,
					this.currentPage * this.perPage
				)
			}
			else
				return this.results?.rows;
		}

		/** Retourne le nombre de lignes totales du tableau */
		private totalRows(): number {
			return this.results?.rows?.length
		}

		/**
		 * Permet de calculer la somme d'une colonne
		 * @param key Clé de la colonne
		 * @param rows Tableau des données
		 */
		private sumColumns(key, rows) {
			let sum = 0;

			// Vérifie qu'on fait pas de somme sur les ratios ni sur les valeurs de facteurs (Si la clé finit par Factor et un nombre)
			if(!key.includes('Ratio') && !(key.match(/Factor\d+$/gi))) {
				for (let row of rows) {
					if(!isNaN(row[key]) && row[key])
						sum += row[key];
				}
			}
			return sum != 0 ? Intl.NumberFormat(this.navLanguage, { 
				maximumFractionDigits: this.getDataPropertyValue(key, 'decimal')
			}).format(sum) : '';
		}

		/** 
		 * Vraiment gros truc crado pas bo pour gérer les décimales 🤮
		 * @todo @garron à virer pour gestion plus propre une fois la tâche https://trello.com/c/GhYcAcbp réalisée !
		 */
		private getDataPropertyValue(key, propertyName) {
			// Expression regulière pour récupérer uniquement les clés commençant par 'Data' suivi par son numéro
			let regex = new RegExp('^Data([0-9])').exec(key.toString());

			console.debug("GridWork - getDataPropertyValue - key : %O - propertyName : %O - regex : %O", key, propertyName, regex);

			// On vérifie si un resultat est trouvé et que le 2eme élement est un nombre
			if(regex && Number(regex[1]))
				return this.configs.WorkParameters.CommonWorkParameters.datas.find(d => d.data == Number(regex[1]))[propertyName];		
		}

		/**
		 * Watcher permettant le calcul du nombre d'élement par page lors du redimensionnement du work
		 */
		@Watch('MaxHeight')
		private resizeTableHeight(){
			let table = document.getElementById(this.$id('GridWork'));
			if (table) {
				// hauteur du texte indiquant les valeurs recalculées des facteurs
				let captionHeight : number = table.querySelector('caption') ? table.querySelector('caption').clientHeight : 0;

				// hauteur des différentes parties du tableau (header, footer, ligne du tableau)
				let headHeight : number = table.querySelector('thead').clientHeight;
				let footHeight : number = table.querySelector('tfoot').clientHeight;
				let lineHeight : number = table.querySelector('tbody tr').clientHeight;

				console.debug("GridWork - resizeTableHeight - headHeight", headHeight );
				console.debug("GridWork - resizeTableHeight - footHeight", footHeight );
				console.debug("GridWork - resizeTableHeight - lineHeight", table.querySelector('tbody tr').scrollHeight );

				// /\D+/gi <== Tout caractère n'étant pas un chiffre en ignorant la casse
				let maxHeight : number = Number(this.MaxHeight.match(/\d+/gi));
				
				if(maxHeight > 0) {
					console.debug("GridWork - resizeTableHeight - maxHeight", maxHeight );

					// Calcul du nombre de page 
					let calcPerPage: number = (maxHeight - (headHeight + footHeight + captionHeight)) / lineHeight;

					console.debug("GridWork - resizeTableHeight - height", (maxHeight - (headHeight + footHeight + captionHeight)) );
					console.debug("GridWork - resizeTableHeight - calcPerPage", calcPerPage );

					// Affectation du nombre de page en recupérant uniquement la partie entière du calcul
					this.perPage = calcPerPage > 1 ? Math.trunc(calcPerPage) : 1;
				}
			}
		}

		created() {
			this.generateTableData();
			this.resizeTableHeight();
		}

		async mounted() {
			/** Initialisation de la machine à état */
			this.initStateMachine<GridState>("Grid", (state, results: any, configs: Dictionary<any>, variant: string) => {
                return new GridContext(state as any, results, configs, variant)
            });
		}

		updated(){
			console.debug("GridWork - Updated");
			
			// Récupération du tableau selon son identifiant
			let table = document.getElementById(this.$id('GridWork'));

			if(table){
				
				// Récupération de la valeur CSS left du tableau et la liste des colonnes DU TABLEAU ayant comme classes stickyCol
				let offsetleft = table.getBoundingClientRect().left;
				let stickyCols = table.querySelectorAll('.stickyCol');

				// Recalcul de la valeur CSS left pour régler le probleme de surperposition des sticky-columns
				stickyCols.forEach((el) => {
					let  {x}  = el.getBoundingClientRect();
					(el as HTMLElement).style.left = `${x - offsetleft}px`;
				})

				// Recalcul nombre d'éléments par page du tableau
				this.resizeTableHeight();
			}
		}
	}
</script>

<style scoped>
	/** Pour que la page active prenne en compte la couleur de Variant */
	:deep(.page-item.active .page-link) {
		background-color: var(--Variant) !important;
	}

	:deep(.page-link:hover) {
		background-color: var(--VariantLight) !important;
	}
</style>
